export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMy40MTQiIGhlaWdodD0iMTMuNDE0IiB2aWV3Qm94PSIwIDAgMTMuNDE0IDEzLjQxNCI+CiAgPGcgaWQ9IkFycm93LWJhc2ljIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDAuNzA3KSI+CiAgICA8cGF0aCBpZD0iQXJyb3ctYmFzaWMtMiIgZGF0YS1uYW1lPSJBcnJvdy1iYXNpYyIgZD0iTTguNDg1LDBWOC40ODVIMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCA2KSByb3RhdGUoLTQ1KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMmQyZDNjIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./images/arrow-basic.svg
// module id = 91
// module chunks = 0